import {
  type CreditCardVendorEnum,
  CreditCardVendors,
} from '@webapp/core/entities/external/CreditCardVendor/CreditCardVendorEnum'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

export const useFormatCreditCardTypeToLabel = () => {
  const intl = useProcurifyIntl()

  return (type: CreditCardVendorEnum) => {
    switch (type) {
      case CreditCardVendors.VISA:
        return intl.formatMessage(messages.visa)
      case CreditCardVendors.MASTERCARD:
        return intl.formatMessage(messages.mastercard)
      case CreditCardVendors.AMERICAN_EXPRESS:
        return intl.formatMessage(messages.americanExpress)
      case CreditCardVendors.DISCOVER:
        return intl.formatMessage(messages.discover)
      case CreditCardVendors.JCB:
        return intl.formatMessage(messages.jcb)
      case CreditCardVendors.DINERS_CLUB:
        return intl.formatMessage(messages.dinersClub)
      case CreditCardVendors.OTHER:
      default:
        return intl.formatMessage(messages.otherCreditCard)
    }
  }
}
